/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import { Badge, Box, Button, Flex, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useDisclosure, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { gql, useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import RichTextEditorViewer from '../../../components/form/RichTextEditorField/viewer';
import RelationCreateModal from './RelationCreateModal';
import useStore from '../../../store';
import c from '../../../constant';

const HEIGHT = '32px';

const Q_RELATION = gql`
	query getNpRelationById($relationId: String!, $excludedNpIds: [String!] = []) {
		getNpRelationById(relationId: $relationId, excludedNpIds: $excludedNpIds) {
			id
			np {
				id
				subject
				type
				step
				number
				createdByUser {
					id
					username
					fullName
					fullNameKhmer
					avatar
				}
				viewers {
					id
					createdAt
					createdBy
					userViewer {
						id
						username
						fullName
						fullNameKhmer
						avatar
						department
						office
					}
				}
			}
			offices
			departments
			relations {
				id
				subject
				type
				step
				number
				createdByUser {
					id
					username
					fullName
					fullNameKhmer
					avatar
				}
				viewers {
					id
					createdAt
					createdBy
					userViewer {
						id
						username
						fullName
						fullNameKhmer
						avatar
						department
						office
					}
				}
			}
		}
	}
`;

function Relation({ relationId = null, excludedNpIds = [], changedStep = null, onChange = () => null }) {
	const toast = useToast();
	const modalCreate = useDisclosure();
	const { push } = useHistory();
	const { t } = useTranslation();
	const { currentUser: user } = useStore((state) => state?.currentUser);
	const [hiddenCreate, setHiddenCreate] = useState(true);
	const [nps, setNps] = useState([]);
	const [getNpRelationById, { data }] = useLazyQuery(Q_RELATION);

	useEffect(() => relationId && load(), [relationId, excludedNpIds, changedStep]);

	useEffect(() => setHiddenCreate(data?.getNpRelationById?.np?.step === 'done'), [data]);

	useEffect(() => data && setNps(data?.getNpRelationById?.relations), [data]);

	function load() {
		getNpRelationById({ variables: { relationId, excludedNpIds } });
	}

	return (
		<>
			<Flex minH={HEIGHT}>
				<Flex justifyContent="flex-start" alignItems="flex-start" minWidth="144px" width="144px" mr={2}>
					<Flex minH={HEIGHT} height={HEIGHT} justifyContent="flex-start" alignItems="center">
						<Text fontWeight="bold">{t('np')}</Text>
					</Flex>
				</Flex>
				<Box width="100%">
					{nps?.length > 0 && (
						<TableContainer mb="2" borderTopWidth={1} borderTopColor="gray.100">
							<Table size="sm" variant="simple">
								<Thead>
									<Tr>
										<Th pl={1} pr={1} pb={2} pt={2}>
											{t('Number')}
										</Th>
										<Th pl={1} pr={1} pb={2} pt={2}>
											{t('Type')}
										</Th>
										<Th pl={1} pr={1} pb={2} pt={2}>
											{t('Subject')}
										</Th>
										<Th pl={1} pr={1} pb={2} pt={2} isNumeric minW="64px">
											{t('Step')}
										</Th>
									</Tr>
								</Thead>
								<Tbody>
									{nps?.map((item, index) => {
										return (
											<Tr key={index} _hover={{ bg: 'gray.100' }}>
												<Td cursor="pointer" pl={1} pr={1} pb={1} pt={1}>
													<Text
														color="#3498DA"
														fontWeight="bold"
														onMouseDown={() => {
															const ids = item?.viewers?.map((viewer) => viewer?.userViewer?.id) || [];
															const canView = ids?.includes(user?.id) || user?.role === 'admin';
															if (canView) {
																push(`/note-of-presentation/detail?id=${item?.id}&type=${item?.type}`);
															} else {
																toast({
																	title: t('Only reviewers can see') + t(item?.type),
																	status: 'warning',
																	isClosable: true,
																	position: 'bottom',
																});
															}
														}}
													>
														{item?.number || 'N/A'}
														<FontAwesomeIcon icon={faExternalLinkAlt} style={{ fontSize: 12, color: '#3498DA', marginLeft: 4 }} />
													</Text>
												</Td>
												<Td pl={1} pr={1} pb={1} pt={1}>
													<Badge>{t(item?.type)}</Badge>
												</Td>
												<Td
													pl={1}
													pr={1}
													pb={1}
													pt={1}
													cursor="zoom-in"
													onMouseDown={(e) => {
														e?.preventDefault();
														const width = 1024;
														const height = 720;
														const x = (screen.width - width) / 2;
														const y = (screen.height - height) / 2;
														const windowFeatures = `width=${width},height=${height},left=${x},top=${y}`;
														window?.open(
															'/#/company-submission-proposal/np/popout?id=' + item?.id + '&from=Relation&preview=true',
															'_blank',
															windowFeatures
														);
													}}
												>
													<Box className="pnplg" display={['none', 'block', 'block']}>
														<RichTextEditorViewer value={item?.subject} makeup={true} />
													</Box>
													<Box className="pnplm" display={['block', 'none', 'none']}>
														<RichTextEditorViewer value={item?.subject} makeup={true} />
													</Box>
												</Td>
												<Td pl={1} pr={1} pb={1} pt={1} isNumeric>
													<Badge>{t(item?.step)}</Badge>
												</Td>
											</Tr>
										);
									})}
								</Tbody>
							</Table>
						</TableContainer>
					)}
					<Box w="100px" mt={nps?.length > 0 ? 4 : 0} hidden={hiddenCreate}>
						<Button
							onMouseDown={modalCreate?.onOpen}
							width="100%"
							leftIcon={<FontAwesomeIcon icon={faPlus} style={{ fontSize: 16 }} />}
							colorScheme="gray"
							variant="solid"
							size="sm"
							borderRadius={c.borderRadius}
							border="1px solid #bdc3c7"
						>
							{t('Create')}
						</Button>
					</Box>
				</Box>
			</Flex>
			{modalCreate?.isOpen && (
				<RelationCreateModal
					relationId={relationId}
					onClose={modalCreate?.onClose}
					onComplete={(np) => {
						setNps([...nps, np]);
						onChange();
					}}
				/>
			)}
		</>
	);
}

export default Relation;
